/**
 * Rote Merkmal-Icons der Matching-Kachel (23.10.2026, ersetzt die Zeile
 * „Wohnraum angeboten"): Nichtraucher (Raucher erlaubt = nein), Auto
 * (Führerschein = ja), Großfamilie (ausgeprägtes Familienleben: Mann, Frau,
 * 2 Kinder). Die Keys liefert die API als `wunsch_icons`; die Symbole stammen
 * aus der Icon-Bibliothek der Pflegeparameter (CareParamIcons).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CareParamIcon, type CareIconKey } from '../care/CareParamIcons';

export const WUNSCH_ICON_KEYS = ['nichtraucher', 'fuehrerschein', 'familienleben'] as const;
export type WunschIconKey = typeof WUNSCH_ICON_KEYS[number];
export const WUNSCH_ICON_COLOR = '#b42318';

export function WunschIcons({ keys, size = 20 }: { keys: string[] | undefined; size?: number }) {
  const { t } = useTranslation();
  const shown = WUNSCH_ICON_KEYS.filter(k => keys?.includes(k));
  if (shown.length === 0) return null;
  return (
    <span data-testid="matching-wunsch-icons" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      {shown.map(k => {
        const label = t(`matching.board.wish.${k}`);
        return (
          <span
            key={k}
            data-wunsch-icon={k}
            title={label}
            role="img"
            aria-label={label}
            style={{ display: 'inline-flex', color: WUNSCH_ICON_COLOR }}
          >
            <CareParamIcon k={k as CareIconKey} size={size} c={WUNSCH_ICON_COLOR} />
          </span>
        );
      })}
    </span>
  );
}
